import { OTPCheckRequest } from '../api/otp/otpcheck/otpcheckrequest';
import { OTPCheckResponse, OTPCheckResponseDtoImpl } from '../api/otp/otpcheck/otpcheckresponse';
import { APIFeatures } from '../util/apifeatures';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { StatusCodes } from '../util/statuscodes';
import { OTPCheckBuilder } from '../dto/otp/otpcheck/otpcheckbuilder';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
/* import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { OTPCheckBuilder } from '../dto/otp/otpcheck/otpcheckbuilder';
import { StatusCodes } from '../util/statuscodes'; */

export class OTPCheckAPIProcessorImpl extends APIProcessorImpl<OTPCheckRequest, OTPCheckResponse>
{
    //  execute()
    //  {
    //      console.log("execute() in GenerateOTPAPIProcessorImpl"); 

    //      let otpCheckResponse = new OTPCheckResponseDtoImpl(APIFeatures.SUCCESS, "OTP validation success");
             
    //      this.getAPISuccess(otpCheckResponse);
    //  } 

    onSuccess(responseMapper: ResponseMapper): void 
    {
        try{
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                if(responseMapper.getStatusCodeOutside() === "SC0000" ||
                responseMapper.getResponseMap().respCode === "000" 
                            || responseMapper.getResponseMap().respCode === "SC0000")
                {
                    let subscriberValidationResponse = new OTPCheckResponseDtoImpl(
                    APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.valid_subscriber));
                    subscriberValidationResponse.setOTPCheckDto(new OTPCheckBuilder(responseMapper.getResponseMap()).buildAll());

                    // this.getContext().getUserContext().setMsisdnB("");
                    this.getContext().getUserContext().setSecToken("");
                                
                    this.getContext().setUserContext(this.getContext().getUserContext());
                    this.getAPISuccess(subscriberValidationResponse);
                }
                else if(responseMapper.getResponseMap().respCode === "100")
                {//non-registered etisalath
                    let subscriberValidationResponse = new OTPCheckResponseDtoImpl(
                    APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.subscriber_not_registered));
    
                    this.getAPIFailure(subscriberValidationResponse);
                }
                else if(responseMapper.getResponseMap().respCode === "002")
                {//password expired/ blocked by admin
                    let subscriberValidationResponse = new OTPCheckResponseDtoImpl(
                    APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.password_blocked));
    
                    this.getAPIFailure(subscriberValidationResponse);
                }
                else
                {
                    //not -registered, not-etisalath
                    let subscriberValidationResponse = new OTPCheckResponseDtoImpl(
                        APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.invalid_mpt_subscriber));
        
                        this.getAPIFailure(subscriberValidationResponse);
                }
            }
             else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new OTPCheckResponseDtoImpl(APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new OTPCheckResponseDtoImpl(APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new OTPCheckResponseDtoImpl(APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }
    
    onFailure(responseMapper: ResponseMapper): void 
    { 
    this.getAPIFailure(new OTPCheckResponseDtoImpl(APIFeatures.OTP_CHECK, responseMapper.getStatusMsg()));
        // if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
        // {
        //         if(responseMapper.getResponseMap().data.responseMap.respCode=== "000" 
        //         || responseMapper.getResponseMap().data.responseMap.respCode === "SC0000")
        //         {
        //             let subscriberValidationResponse = new OTPCheckResponseDtoImpl(
        //             APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.valid_subscriber));
        //             subscriberValidationResponse.setOTPCheckDto(new OTPCheckBuilder(responseMapper.getResponseMap()).buildAll());
        //             this.getAPISuccess(subscriberValidationResponse);
        //         }
        //         else if(responseMapper.getResponseMap().data.responseMap.respCode === "100")
        //         {//non-registered etisalath
        //             let subscriberValidationResponse = new OTPCheckResponseDtoImpl(
        //             APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.subscriber_not_registered));

        //             this.getAPIFailure(subscriberValidationResponse);
        //         }
        //         else if(responseMapper.getResponseMap().data.responseMap.respCode === "002")
        //         {//password expired/ blocked by admin
        //             let subscriberValidationResponse = new OTPCheckResponseDtoImpl(
        //             APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.password_blocked));

        //             this.getAPIFailure(subscriberValidationResponse);
        //         }
        //         else
        //         {
        //             //not -registered, not-etisalath
        //             let subscriberValidationResponse = new OTPCheckResponseDtoImpl(
        //                 APIFeatures.OTP_CHECK, this.getContext().getResources().getString(Strings.invalid_mpt_subscriber));

        //                 this.getAPIFailure(subscriberValidationResponse);
        //         }
        //     }
        //     else
        //     {
        //     }
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/otpcheckapiprocessor.tsx